"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const featuresData = [{
  title: "Professionnalisme",
  description: "Chaque mission est menée avec une exigence de qualité, de rigueur et de respect des engagements.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/consulting_professionalism.png",
  imageAlt: "Expertise en conseil et stratégie de formation",
  linkText: "Découvrir mon parcours",
  linkUrl: "/WhoAmIPage"
}, {
  title: "Bienveillance",
  description: "Je crois en un accompagnement respectueux, à l’écoute et sans jugement. Mon rôle est d’aider vos équipes à progresser, pas de pointer les manquements.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606874/img/collaboration_bienveillance.png",
  imageAlt: "Collaboration et échange bienveillant",
  linkText: "Ma démarche qualité",
  linkUrl: "/ProfessionalTrainingQualityPage"
}];
export default function FeaturesList() {
  return <section data-section-id="165419" id="mesvaleurs" className="bg-background ![padding:0px_0px_96px_0px]">
      
    </section>;
}